export enum ProductTypeEnum {
  Paid = 'paid',
  Sample = 'sample',
  Free = 'free',
}
